/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ForecastModelAggregationLevel', 'model/ForecastModelAggregationReport', 'model/ForecastModelAggregationLevelReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/ForecastModelAggregationLevel'), require('../model/ForecastModelAggregationReport'), require('../model/ForecastModelAggregationLevelReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForecastModelAggregationLevelApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.ForecastModelAggregationLevel, root.ForStractionServiceApi.ForecastModelAggregationReport, root.ForStractionServiceApi.ForecastModelAggregationLevelReport);
  }
}(this, function(ApiClient, ForecastModelAggregationLevel, ForecastModelAggregationReport, ForecastModelAggregationLevelReport) {
  'use strict';

  /**
   * ForecastModelAggregationLevel service.
   * @module api/ForecastModelAggregationLevelApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new ForecastModelAggregationLevelApi. 
   * @alias module:api/ForecastModelAggregationLevelApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the forecastModelAggregationLevelAddAllPut operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForecastModelAggregationLevel>} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.autoSubdivide  (default to false)
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.forecastModelAggregationLevelAddAllPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAggregationLevelAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'autoSubdivide': opts['autoSubdivide']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelAddPut operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelAggregationLevel} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.autoSubdivide  (default to false)
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.forecastModelAggregationLevelAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAggregationLevelAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'autoSubdivide': opts['autoSubdivide']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelAggregateDataGet operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAggregateDataGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/ForecastModelAggregationReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateData
     * @param {String} _4SAPIAppID 
     * @param {Integer} levelID 
     * @param {Boolean} preview 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.sumPeriodValues  (default to false)
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelAggregateDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/ForecastModelAggregationReport>}
     */
    this.forecastModelAggregationLevelAggregateDataGet = function(_4SAPIAppID, levelID, preview, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelAggregateDataGet";
      }

      // verify the required parameter 'levelID' is set
      if (levelID == undefined || levelID == null) {
        throw "Missing the required parameter 'levelID' when calling forecastModelAggregationLevelAggregateDataGet";
      }

      // verify the required parameter 'preview' is set
      if (preview == undefined || preview == null) {
        throw "Missing the required parameter 'preview' when calling forecastModelAggregationLevelAggregateDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'levelID': levelID,
        'preview': preview,
        'sumPeriodValues': opts['sumPeriodValues']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [ForecastModelAggregationReport];

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/aggregateData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelDeleteAllPut operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelAggregationLevelDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAggregationLevelDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelDeleteGet operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} levelID 
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelAggregationLevelDeleteGet = function(_4SAPIAppID, levelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelDeleteGet";
      }

      // verify the required parameter 'levelID' is set
      if (levelID == undefined || levelID == null) {
        throw "Missing the required parameter 'levelID' when calling forecastModelAggregationLevelDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'levelID': levelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelEditAllPut operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/ForecastModelAggregationLevel>} body 
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelAggregationLevelEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAggregationLevelEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelEditPut operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/ForecastModelAggregationLevel} body 
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.forecastModelAggregationLevelEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling forecastModelAggregationLevelEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the forecastModelAggregationLevelLoadGet operation.
     * @callback module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ForecastModelAggregationLevelReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} levelID 
     * @param {module:api/ForecastModelAggregationLevelApi~forecastModelAggregationLevelLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/ForecastModelAggregationLevelReport}
     */
    this.forecastModelAggregationLevelLoadGet = function(_4SAPIAppID, levelID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling forecastModelAggregationLevelLoadGet";
      }

      // verify the required parameter 'levelID' is set
      if (levelID == undefined || levelID == null) {
        throw "Missing the required parameter 'levelID' when calling forecastModelAggregationLevelLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'levelID': levelID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ForecastModelAggregationLevelReport;

      return this.apiClient.callApi(
        '/ForecastModelAggregationLevel/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
